import { Button, useDataProvider } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { normalizeFilterForm } from './util';
import { saveAs } from '../../util/saveAs';


const MetricExportButton = () => {
	const { getValues } = useFormContext();
	const filter = getValues();
	const dataProvider = useDataProvider();

	const exportData = async () => {
		normalizeFilterForm(filter);

		const csvdata = await dataProvider.getAnalyticsCSV({ filter });
		saveAs( csvdata.data, 'export.csv', 'text/csv' );
	}

	return <Button label="Export" onClick={exportData} />;
}


export default MetricExportButton;